import { render, staticRenderFns } from "./Province.vue?vue&type=template&id=ec637788&scoped=true"
import script from "./Province.vue?vue&type=script&lang=js"
export * from "./Province.vue?vue&type=script&lang=js"
import style0 from "./Province.vue?vue&type=style&index=0&id=ec637788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec637788",
  null
  
)

export default component.exports